import { PayloadAction } from '@reduxjs/toolkit'

import { IPartnerRecord } from 'clickNgo/entities/partner/models'

import { IInitPartnerDashboardParams } from '../actions/initPartnerDashboardAction'
import { IPartnerDashboardState } from '../models'

export const initPartnerDashboardPending = (state: IPartnerDashboardState) => {
  state.isInitialized = false
  state.isLoading = true
}

export const initPartnerDashboardRejected = (state: IPartnerDashboardState) => {
  state.isInitialized = false
  state.isLoading = false
}

export const initPartnerDashboardFulfilled = (
  state: IPartnerDashboardState,
  action: PayloadAction<
    { partnerList: IPartnerRecord[]; userHistoryList: IPartnerRecord[] },
    string,
    { arg: IInitPartnerDashboardParams }
  >
) => {
  const { payload } = action

  state.isInitialized = true
  state.isLoading = false

  state.userHistoryList.data = payload.userHistoryList
  state.userPartnerList.data = payload.partnerList
}
